export const Footer = () => (
  <footer className="border-t border-zinc-200 bg-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 text-sm text-zinc-500">
        <img src="/images/logo.png" alt="I&G Grafiche" className="h-9 w-auto" data-testid="footer-logo" />
        <div className="flex gap-8">
          <a href="#servizi" className="hover:text-zinc-900 transition-colors" data-testid="footer-link-servizi">Servizi</a>
          <a href="#lavori" className="hover:text-zinc-900 transition-colors" data-testid="footer-link-lavori">Lavori</a>
          <a href="#contatti" className="hover:text-zinc-900 transition-colors" data-testid="footer-link-contatti">Contatti</a>
        </div>
        <p>© {new Date().getFullYear()} I&G Grafiche · P.IVA 14537850969</p>
      </div>
    </div>
  </footer>
);
